import { Injectable } from '@angular/core';
import {environment} from 'projects/goal-setting-ui/src/environments/environment';
import {RestApiService} from 'projects/goal-setting-ui/src/app/services/rest/rest-api.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class GoalSettingService extends RestApiService {
  getHeadersForOpenAPI(){
    return  {
      subtenantId:'1',
    }
  }
getQuestions(){
  let url:any = environment.GOAL_SETTING_URL+'api/noauth/goalSetting/getGoalOpenQuestions';
  return this.getWithHeaders(url, this.getHeadersForOpenAPI());
}
getAimsForSelectedgradeAndExam(gradeId:any,examId:any){
  let url:any = environment.GOAL_SETTING_URL+'api/noauth/goalSetting/getAims?examId='+examId+'&gradeId='+gradeId;
  return this.getWithHeaders(url, this.getHeadersForOpenAPI());
}
getColleges(aimId:any, examId:any){
  let url:any = environment.GOAL_SETTING_URL+'api/noauth/goalSetting/getCollegesByAims?aims='+aimId+'&examId='+examId;
  return this.getWithHeaders(url, this.getHeadersForOpenAPI());
}
getRankData(examName:any,selectedRank:any,aimName:any){
  let url:any = environment.GOAL_SETTING_URL+'api/noauth/goalSetting/getRankData?examId='+examName+'&selectedRank='+selectedRank;
  return this.getWithHeaders(url,this.getHeadersForOpenAPI()); 
}
verifyPhoneNumber(payload:any){
      let header = new HttpHeaders().set('X-Page', 'REGISTER_VALIDATE').append('X-Product', '1' )
  let url:any = environment.UAM_URL+'api/users/verifyPhone';
  return this.post(url, payload,'');
}
generateOTP(payload:any){
  let url:any = environment.UAM_URL+'api/authentication/generateOTP';
  return this.post(url, payload,'');
}
validateOTP(payLoad:any){
  let url:any = environment.UAM_URL+'api/authentication/validateOTP?isBearerRequired=true';
  return this.post(url, payLoad,''); 
}
updateUserExams(payLoad:any,userId:any,token:any){
  let header = {
    "authorization": "Bearer "+token
  }
  let url:any = environment.UAM_URL+'api/users/'+userId;
  return this.put(url, payLoad,header); 
}

getUserSubjects(userId:any,examId:any,subtenantId:any, token:any){
  let url =environment.CMS_URL+ `examtoc/v2/getSubjectsForExam/${examId}?status=${"active"}&subtenantIds=${subtenantId}`;
  let headers = {
    'authorization': 'Bearer ' + token,
    'userId': userId + ""
  };
  return this.getWithHeaders(url, headers); 
}
updateGoal(payLoad:any,userDto:any,token:any){
  let url= environment.GOAL_SETTING_URL +'api/goalSetting/updateGoal';
  // let headers = new HttpHeaders().set('authorization',  'Bearer ' + token).set('Content-Type', 'application/json').set('userId',userDto.userId + "")
  // .set('tenantId',userDto.tenantId).set('subtenantId',userDto.subTenant);
  let headers:any = {
    'authorization': 'Bearer ' + token,
    'userId': userDto.userId + "",
    'tenantId': userDto.tenantId, 
    'subtenantId': userDto.subTenant

  };
  return this.put(url, payLoad,headers); 
}

}
